import React from 'react'

import useTemplateId from '../../../hooks/useTemplateId'
import ConfiguratorActionButtons from 'components/ConfiguratorActionButtons'
import SlideInWrapper from 'components/SlideInWrapper'
import UnsavedChangesModal from 'components/UnsavedChangesModal'
import MessengerForm from 'components/forms/MessengerForm'
import { useFormState } from 'hooks/useFormState'
import useSectionOpenedTracking from 'hooks/useSectionOpenedTracking'
import { useUnsavedChangesModal } from 'hooks/useUnsavedChangesModal'

function Messenger() {
	const formId = 'messenger'
	const [state, handlers] = useFormState()
	const formRef = React.useRef<HTMLFormElement>(null)
	const { hideModal, handleDiscardChanges } = useUnsavedChangesModal(formRef, state.isDirty)
	const { templateId } = useTemplateId()

	useSectionOpenedTracking()

	return (
		<>
			<UnsavedChangesModal onDiscardChanges={handleDiscardChanges} onStayHere={hideModal} name="Messenger" />
			<SlideInWrapper>
				<MessengerForm key={templateId} id={formId} {...handlers} />
				<ConfiguratorActionButtons formId={formId} {...state} />
			</SlideInWrapper>
		</>
	)
}

export default Messenger
